/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * ThreeCardDailyGameHandBase
 * auto generated base class for the model ThreeCardDailyGameHandModel.
 */
export const ThreeCardDailyGameHandModelBase = ModelBase.named('ThreeCardDailyGameHand')
  .props({
    __typename: types.optional(types.literal('ThreeCardDailyGameHand'), 'ThreeCardDailyGameHand'),
    cards: types.union(types.undefined, types.array(types.string))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ThreeCardDailyGameHandModelSelector extends QueryBuilder {
  get cards() {
    return this.__attr('cards')
  }
}
export function selectFromThreeCardDailyGameHand() {
  return new ThreeCardDailyGameHandModelSelector()
}

export const threeCardDailyGameHandModelPrimitives = selectFromThreeCardDailyGameHand().cards
